import { color } from 'd3-color';

function changeColorOpacity(colorString, opacity = 1) {
  const rgbColor = color(colorString);

  if (rgbColor == null) {
    throw new Error('Color value is not valid.');
  }

  rgbColor.opacity = opacity;
  return rgbColor.toString();
}
function changeGradientOpacity(gradient, opacity = 1) {
  return gradient.map(({
    offset,
    color
  }) => ({
    offset,
    color: changeColorOpacity(color, opacity)
  }));
}

export { changeColorOpacity, changeGradientOpacity };
